/* globals CWB_API_ENV */
import React from 'react';
import { Input } from 'reactstrap';
import { getI18n, Trans, withI18n } from 'react-i18next'

import styled, { css } from 'styled-components';

const AcceptTerms = ({
  t,
  isSelected,
  message,
  onChange
}) => {
  if (!message) message = t(
    'Please review and accept the terms and conditions below in order to continue.'
  );

  const isLangSpanish = getI18n().language === 'es';

  const terms = isLangSpanish
    ? CWB_API_ENV.termsEs
    :`${CWB_API_ENV.domain}/terms_conditions.asp`;
  const privacy = isLangSpanish
    ? CWB_API_ENV.privacyEs
    : `${CWB_API_ENV.domain}/privacy.asp`;

  return (
    <Wrapper>
      <StyledDiv>
        <Checkbox type="checkbox" id="accept-terms" checked={isSelected} onChange={onChange} />
        <Accept>
          <AcceptLabel>
            <Trans i18nKey="acceptTerms">
              I agree to the <a href={terms} rel="noopener noreferrer" target="_blank">Terms of Use</a> and <a href={privacy} rel="noopener noreferrer" target="_blank">Privacy Policy</a>
            </Trans>
          </AcceptLabel>
        </Accept>
      </StyledDiv>
      {message && message.length > 0 && (
        <Label style={{ color: '#C7053F' }}>
          {t(message)}
        </Label>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 8px 0px 8px 0px;
`

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

const Checkbox = styled(Input)`
  position: initial;
  margin: 0px;
  margin-right: 8px;
`

const Label = styled.div`
  font-size: 13px;
`

const AcceptLabel = styled(Label)`
  display: inline;
`

const Accept = styled.div`
  display: inline;

  a {
    color: #00AAFF;
  }
`

export default withI18n()(AcceptTerms);
